import { Reducer } from 'react'
import { GET_WORKLOAD_SHARE_SUMMARY_SUCCESS } from './actions'

export type AccessType =
  | 'Read only (Read-only access to the workload.)'
  | 'Write access'

export interface ShareWorkloadFormValues {
  share: {
    shareType: string
    awsAccountID: string
    otherAWSAccount: string
    IAMUserRoleARN: string
    accessType: AccessType
  }
}

export interface ShareInput {
  shareType: string
  awsAccountID: string
  otherAWSAccount: string
  IAMUserRoleARN: string
}

export interface WorkloadShareSummary {
  shareId: string
  sharedWith: string
  permissionType: string
  status: string
}

export interface WorkloadShareListState {
  workloadId: string
  workloadShareSummaries: WorkloadShareSummary[]
  totalShareCount: number
}

const initialState: WorkloadShareListState = {
  workloadId: '',
  workloadShareSummaries: [],
  totalShareCount: 0,
}

export type WorkloadActionType = {
  type: typeof GET_WORKLOAD_SHARE_SUMMARY_SUCCESS
  payload: WorkloadShareListState
}

export const reducer: Reducer<WorkloadShareListState, WorkloadActionType> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case GET_WORKLOAD_SHARE_SUMMARY_SUCCESS:
      return {
        ...state,
        workloadId: action.payload.workloadId,
        workloadShareSummaries: action.payload.workloadShareSummaries,
        totalShareCount: action.payload.totalShareCount,
      }
    default:
      return state
  }
}
